module.exports = __webpack_public_path__ + "static/media/closeMenuIcon.c2b7fd30.svg";